import React, { useEffect } from "react";
import "./style.scss";
import { Container, Row, Col } from "react-bootstrap";
import SigninPage from "./SigninPage";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import { useLocation, useNavigate, Link } from "react-router-dom";
import MFADialog from "./MFADialog/index";

const LoginPage = () => {
  const location = useLocation();
  const isForgotPassword = location.pathname.includes("/ForgotPassword");
  const isResetPassword = location.pathname.includes("/resetPassword");
  const isMFAOptions = location.pathname === "/mfa-options";
  const navigate = useNavigate();

  const handleCloseMFADialog = () => {
    navigate("/Dashboard");
  };

  const renderForm = () => {
    return isForgotPassword ? (
      <ForgotPassword />
    ) : isResetPassword ? (
      <ResetPassword />
    ) : (
      <SigninPage />
    );
  };
useEffect(() => {
  const isKeyboardUser = () => {
    let usingKeyboard = false;

    const handleKeyDown = () => (usingKeyboard = true);
    const handleMouseDown = () => (usingKeyboard = false);

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousedown", handleMouseDown);

    setTimeout(() => {
      if (usingKeyboard) {
        document.getElementById("goToHomepage")?.focus({ preventScroll: true });
      }
    }, 200);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousedown", handleMouseDown);
    };
  };

  isKeyboardUser();
}, []);
  return (
    <>
      <div
        className={`Login_container ${
          isForgotPassword ? "forgetPage" : "mainLoginPage"
        }`}
      >
        <Container>
          <div className="header">
            <Row>
              <Col xl={6}>
                <Link to="/" className="logoImg" aria-label="Lockdown Experts Logo"  id="goToHomepage"></Link>
              </Col>
              <Col xl={6}>
                <div className="needAndsupport">
                 <Link
                    to="/needAssistanceandsupport"
                    className="needsupportAnchor"
                    aria-label="Need Assistance? Help & Support (opens in a new tab)"
                  >
                    Need Assistance? Help & Support
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
          <div className="middleContainer">
            <Row>
              <Col xl={7}>
                <div className="left-section">
                  <div className="branding">
                    <p className="tagline" role="heading" aria-level="2">Central Monitoring System</p>
                    <p className="description">
                      Authorized personnel only. Ensure security and efficiency
                      with real-time monitoring. Monitor. Analyze. Respond. Stay
                      in control 24/7.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xl={5}>
                <div className="right_wrapper">{renderForm()}</div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <footer>
        <Container>
          <Row>
            <Col xl={6}>
              <p className="left">Lockdown. Save lives.</p>
            </Col>
            <Col xl={6}>
              <p className="right">
                &copy; 2024 Lockdown Experts, LLC.All rights reserved.
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
      {isMFAOptions && <MFADialog open={true} onClose={handleCloseMFADialog} />}
    </>
  );
};

export default LoginPage;
